<div class='container-tab uploaded-file-tab' #container>
  <div class="form-container" [ngClass]="{ 'mt-4': playlist.IsAndroid }" *ngIf="{ isMawChrome: selectedLauncher | isMawChromeLauncher } as launcher">

    @if (!playlist.IsAndroid) {
      <select class="w-100 mb-3 location-select" (change)="onLocationChanged($event.target.value)"
        [class.selected]="selectedlocation" [disabled]="playlist.MachinePhysicalAddress">
        <option selected value="" class="d-none">{{selectedlocation ? selectedlocation :
          'Choose a location' }}
        </option>
        <option class="option-to-select" *ngFor='let location of locations' [value]="location.PhysicalAddress">
          {{location.Title}}
        </option>
        <option *ngIf="!locations.length" disabled>There are no available locations</option>
      </select>
    }

    <ng-container *ngIf="playlist?.MachinePhysicalAddress || selectedlocation || playlist.IsAndroid">
      @if (!playlist.IsAndroid) {
        <div class="form-group row invisible-border">
          <label for="Name" class="col-md-3" matTooltip="Short description">Name</label>
          <input type="text" class="col-md-5" id="Name" placeholder="Short description" [(ngModel)]="playlistItemName">
        </div>
      }

      <div class="form-group row invisible-border" *ngIf="launchers && !playlist.IsAndroid">
        <label for="OpenWith" class="col-md-3" matTooltip="Application which will play a playlist item">Application</label>
        <mat-select class="col-md-5 pr-0" id="OpenWith" [(ngModel)]="selectedLauncher" name="launcher" panelClass="launcher-select"
          [class.invalid-input]="application.touched && application.errors" (selectionChange)="onLauncherChange($event.value)"
          [disableOptionCentering]="true" #application="ngModel" required>
          <mat-select-trigger>
            <img *ngIf="selectedLauncher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + selectedLauncher.LauncherImage"/>
            <ng-template #icon>
              <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
            </ng-template>
            <span>{{ selectedLauncher?.LauncherTitle }}
              <ng-container *ngIf="selectedLauncher?.LauncherDescription">
                ({{ selectedLauncher.LauncherDescription }})
              </ng-container>
            </span>
          </mat-select-trigger>
          <mat-option value="image" *ngFor='let launcher of launchers | launcherSort' [value]="launcher">
            <img *ngIf="launcher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + launcher.LauncherImage"/>
            <ng-template #icon>
              <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
            </ng-template>
            <span>{{ launcher.LauncherTitle }}
              <ng-container *ngIf="launcher.LauncherDescription">
                ({{ launcher.LauncherDescription }})
              </ng-container>
            </span>
          </mat-option>
          <mat-option *ngIf="!launchers || !launchers.length" disabled>There are no
            {{ playlist.MachinePhysicalAddress ? 'local' : 'common'}} launchers</mat-option>
        </mat-select>

        <mcl-mode-select *ngIf="launcher.isMawChrome" [item]="playlistItem" [parentContainer]="container"
          [rss]="playlistItem.RssConfigs" (changeMode)="onChangeMCLMode(this.playlistItem, $event)">
        </mcl-mode-select>

        <div *ngIf="application.touched && application.errors?.required" class="col-md-4 invalid-input">
          The field is required!
        </div>
      </div>

      @if (launcher.isMawChrome) {
        <ng-container *ngTemplateOutlet="sortBySelector"></ng-container>
      }

      @if (playlist.IsAndroid) {
        <div class="form-group row invisible-border">
          <label for="SharedFolder" class="col-md-3 local" matTooltip="Path to a shared folder">
            Shared folder
          </label>
          <input type="text" class="col-md-5" id="SharedFolder" placeholder="C:\Shared , \\server\shared"
            [(ngModel)]="playlistItem.CustomParameters">
        </div>

        <ng-container *ngTemplateOutlet="sortBySelector"></ng-container>

        <div class="form-group row">
          <label for="Duration" class="col-md-3" matTooltip="Time spent on each item in the shared folder">
            Time spent per item
          </label>

          <div class="col-md-4 invisible-border duration-wrapper">
            <duration-picker [(duration)]="playlistItem.FolderItemDuration"></duration-picker>
          </div>

          <div class="col-md-1 d-flex align-items-center">
            <mat-slide-toggle [(ngModel)]="playlistItem.UseExactFolderDuration" matTooltip="Use exact folder duration"></mat-slide-toggle>
          </div>
        </div>
      }
      @else {
        <div [class.my-4]="launcher.isMawChrome">
          @for (source of playlistItem.PlaylistItemLinks; track $index; let i = $index) {
            <div class="form-group row invisible-border">
              <label for="CustomParameters" class="col-md-3 local" matTooltip="Parameters for a playlist item">
                <div class="monitor-index local-file" *ngIf="launcher.isMawChrome">{{ i + 1 }}</div>
                Custom Parameters
              </label>
              <input type="text" class="col-md-5" id="CustomParameters{{i}}" (input)="customParametersSubject.next(source)"
                [(ngModel)]="source.Link">

              <zoom-input *ngIf="launcher.isMawChrome && source.Link"
                [source]="source" [item]="playlistItem"></zoom-input>
            </div>

            <div class="form-group row" *ngIf="launcher.isMawChrome && source.Duration">
              <label for="itemDuration" class="col-md-5">Time spent on each item in the folder</label>
              <div class="col-md-3 invisible-border duration-wrapper">
                <duration-picker [(duration)]="source.Duration">
                </duration-picker>
              </div>
            </div>
          }
        </div>
      }

      <div class="form-group row">
        <label for="Duration" class="col-md-3" matTooltip="Playlist item duration">
          Set Duration
        </label>
        <div class="col-md-5 invisible-border duration-wrapper">
          <duration-picker [(duration)]="playlistItem.Duration" [disabled]="playlistItem.UseExactFolderDuration">
          </duration-picker>
        </div>
      </div>

      @if (launcher.isMawChrome || !hasRssForegroundItem) {
        <rss-source class="mb-4" [playlist]="playlist" [playlistItem]="playlistItem"></rss-source>
      }

      @if (launcher.isMawChrome) {
        <div class="row no-gutters mb-1">
          <div class="col-md-3">
            <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.UseExactFolderDuration" class="light">
              Use exact folder duration
            </mat-checkbox>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-md-3">
            <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsContentStretched" name="IsContentStretched"
              class="light" matTooltip="Item content will be stretched" (change)="onStretchContentChanged(playlistItem)">
              Stretch content
            </mat-checkbox>
          </div>
        </div>
      }

      <ng-container *ngIf="playlistItem.LocalLauncher && playlistItem.LauncherId">
        <div class="row no-gutters" *ngIf="selectedLauncher?.IsFullScreen">
          <div class="col-md-3">
            <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.OpenInFullScreen" name="OpenInFullScreen"
              class="light" matTooltip="Playlist item will be opened in full screen">
              Open in Full Screen
            </mat-checkbox>
          </div>
        </div>

        <app-launcher-features [launcherFeatures]="playlistItem.launcherFeatures"></app-launcher-features>
      </ng-container>

      <div class="row no-gutters mt-4" *ngIf="playlist.IsAndroid">
        <playlist-item-advanced-options [item]="playlistItem"></playlist-item-advanced-options>
      </div>
    </ng-container>
  </div>

  <mat-toolbar class="tab-footer unset">
    <mat-checkbox *ngIf="!playlistItem.Id" [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
      class="light" matTooltip="Add one more item to the Playlist">Add Another</mat-checkbox>

    <button type="button" mat-raised-button (click)="cancel()" mat-flat-button matTooltip="Cancel">Cancel</button>
    <button type="submit" (click)="submit()" [disabled]="isSubmitButtonDisabled()" mat-flat-button matTooltip="Save">Save</button>
  </mat-toolbar>

</div>

<ng-template #sortBySelector>
  <div class="form-group row invisible-border">
    <label for="SortBy" class="col-md-3" matTooltip="Playlist items sort order">Sort by</label>
    <mat-select class="col-md-5 pr-0" id="SortBy" [(ngModel)]="playlistItem.Order" name="sortBy"
      panelClass="launcher-select" [disableOptionCentering]="true">
      @for (entry of sortOrderEntries; track $index) {
        <mat-option [value]="entry.value">{{ entry.label }}</mat-option>
      }
    </mat-select>
  </div>
</ng-template>
